import { render, staticRenderFns } from "./TaskVideoRec.vue?vue&type=template&id=7f5db8b8&"
import script from "./TaskVideoRec.vue?vue&type=script&lang=js&"
export * from "./TaskVideoRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports